import { useEffect, useState } from 'react'

interface DifferentInitialRenderProps {
  initial: () => JSX.Element
  next: () => JSX.Element
}
const DifferentInitialRender = ({
  initial,
  next,
}: DifferentInitialRenderProps) => {
  const [isInitial, setInitial] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        setInitial(false)
      }
    }, 1)
  }, [])

  return isInitial ? initial() : next()
}

export default DifferentInitialRender
